<p>setup-wizard-view-previous-jobs works!</p>
